var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9015 31.21L12.5047 22.3268L9.75793 26.1412L18.9015 38.8388L37.7579 12.6532L35.0112 8.83878L18.9015 31.21Z",
    fill: "#39AE68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7579 0.640167H28.7579C38.6991 0.640167 46.7579 8.69904 46.7579 18.6402V28.6402C46.7579 38.5813 38.6991 46.6402 28.7579 46.6402H18.7579C8.81681 46.6402 0.757935 38.5813 0.757935 28.6402V18.6402C0.757935 8.69904 8.81681 0.640167 18.7579 0.640167ZM18.7579 3.64017C10.4737 3.64017 3.75793 10.3559 3.75793 18.6402V28.6402C3.75793 36.9244 10.4737 43.6402 18.7579 43.6402H28.7579C37.0422 43.6402 43.7579 36.9244 43.7579 28.6402V18.6402C43.7579 10.3559 37.0422 3.64017 28.7579 3.64017H18.7579Z",
    fill: "#424242"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.6c2804d38f8d132b5d987f0ad521e33c.svg";
export { ForwardRef as ReactComponent };